import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

/**
 * Provides dot navigation for Embla carousels.
 *
 * Exports:
 * - useDotButton(emblaApi): tracks selected slide index and snap points,
 *   and provides a click handler for dot-to-slide navigation.
 */
export const useDotButton = (emblaApi) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const onDotButtonClick = useCallback(
    (index) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  const onInit = useCallback((api) => {
    setScrollSnaps(api.scrollSnapList())
  }, [])

  const onSelect = useCallback((api) => {
    setSelectedIndex(api.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onInit(emblaApi)
    onSelect(emblaApi)

    emblaApi.on('reinit', onInit).on('reinit', onSelect).on('select', onSelect)
  }, [emblaApi, onInit, onSelect])

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick
  }
}

export const DotButton = (props) => {
  const { children, className = '', onClick } = props

  return (
    <button type="button" className={className} onClick={onClick}>
      {children}
    </button>
  )
}

DotButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func
}

DotButton.defaultProps = {
  children: null,
  className: '',
  onClick: undefined
}
